import axiosInstance from "../axiosInstance";

export const GETListarDisponibles = async (type = null) => {
  try {
    // Construir la URL con query param si type existe
    let url = `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/listar-disponibles`;
    if (type) {
      const queryParams = new URLSearchParams({ smatip: type });
      url += `?${queryParams.toString()}`;
    }

    const response = await axiosInstance.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETListarDisponibles;
